goog.provide("shadow.js.shim.module$dayjs$locale$ar_sa");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ar_sa");
shadow.js.shim.module$dayjs$locale$ar_sa = shadow.js.nativeProvides["dayjs/locale/ar-sa"] = require("dayjs/locale/ar-sa");
module$shadow_js_shim_module$dayjs$locale$ar_sa.default = shadow.js.shim.module$dayjs$locale$ar_sa;
